import useId from '../utils/useId';
import * as React from 'react';
export const bigpaySvg = React.forwardRef(function bigpaySvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_bigpay__a_${id_0})`,
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm28.767 14.183-1.618 2.195.463.694h.924l1.964-2.889h-1.733Z',
      stroke: '#fff',
      strokeWidth: 0.2,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.5 14.434c0 1.873.004 2.242.028 2.385.165 1.015.94 1.741 2.032 1.903.252.038.69.038.914 0a2.667 2.667 0 0 0 1.42-.732c.343-.345.547-.714.654-1.193.036-.163.033-.692-.008-.895-.22-1.101-1.044-1.784-2.242-1.857-.549-.035-1.132.13-1.438.405l-.094.085v-2.316H1.5v2.215Zm2.983.8c.35.115.635.39.753.726.09.26.097.512.024.791a1.096 1.096 0 0 1-.318.523c-.233.231-.471.332-.827.352a1.25 1.25 0 0 1-1.028-.403c-.561-.606-.35-1.628.406-1.949.187-.079.319-.1.585-.095.218.005.279.014.405.055Zm6.589-1.18a2.698 2.698 0 0 0-1.554.734c-.474.468-.701.996-.701 1.624-.002 1.214.745 2.1 1.94 2.306.186.031.27.035.55.027.332-.009.468-.029.706-.106.182-.057.4-.17.53-.275l.118-.096-.011.31c-.008.237-.019.342-.048.445-.136.467-.475.79-.945.893a1.712 1.712 0 0 1-.754-.035 1.185 1.185 0 0 1-.83-1.02l-.01-.128H8.857v.07c0 .352.132.816.323 1.144.116.193.435.521.639.654.258.168.596.295.97.365.244.046.859.046 1.087 0 .537-.11 1.005-.349 1.355-.7a2.24 2.24 0 0 0 .655-1.368c.011-.11.017-.668.011-1.505-.005-1.291-.007-1.335-.045-1.508a3.172 3.172 0 0 0-.088-.312c-.285-.793-.99-1.347-1.898-1.492a3.927 3.927 0 0 0-.794-.027Zm.741 1.187c.505.174.806.602.807 1.143 0 .107-.007.231-.018.279-.132.582-.626.969-1.238.969-.723 0-1.28-.534-1.277-1.228.001-.422.19-.79.519-1.014.246-.167.442-.219.793-.211.229.005.273.012.414.062Zm4.897-1.187c-1.111.134-2.016.917-2.217 1.921-.039.182-.039.235-.039 2.554v2.369h1.266V19.64c0-.692.004-1.257.007-1.257.006 0 .057.03.116.064.332.2.74.303 1.21.303.306 0 .531-.035.788-.12a2.483 2.483 0 0 0 1.422-1.172c.178-.337.25-.6.268-.974.055-1.213-.75-2.183-1.989-2.394a3.737 3.737 0 0 0-.831-.037Zm.727 1.18c.35.115.635.39.753.728.156.448.06.938-.246 1.27-.242.26-.573.4-.95.4-.71 0-1.272-.54-1.274-1.226 0-.433.202-.813.556-1.038.235-.15.42-.197.756-.19.218.006.279.015.405.056Zm4.681-1.18c-.982.114-1.831.763-2.14 1.636a1.983 1.983 0 0 0-.117.74c.004.664.222 1.22.646 1.644.257.257.54.427.897.548.497.168 1.176.175 1.644.017a1.71 1.71 0 0 0 .538-.282.677.677 0 0 1 .104-.083c.006 0 .011.099.011.22v.22h1.25l-.008-1.326c-.005-1.285-.007-1.33-.046-1.503-.22-.978-.946-1.633-1.994-1.804a3.811 3.811 0 0 0-.785-.027Zm.741 1.187c.51.178.805.602.805 1.16a1.1 1.1 0 0 1-.132.57 1.226 1.226 0 0 1-.858.635 1.62 1.62 0 0 1-.631-.02 1.22 1.22 0 0 1-.91-1.193 1.2 1.2 0 0 1 .519-1.003c.245-.167.442-.219.792-.211.23.005.274.012.415.062ZM6.986 16.44v2.293h1.285v-4.587H6.986v2.293Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.819 14.223c.018.044.427.978.91 2.079l.91 2.077.033.077-.791 1.134-.851 1.221-.063.087h1.553l.768-1.105.852-1.22.078-.116-.293-.673-.508-1.161c-.118-.268-.41-.934-.648-1.481l-.435-.994-.774-.002h-.774l.033.077Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_bigpay__a_${id_0}`,
          x1: 0,
          y1: 0,
          x2: 32,
          y2: 32,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#5E7AE9',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#16EDDC',
        }),
      ),
    ),
  );
});
bigpaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bigpay = {
  category: 'brand',
  colorable: false,
  name: 'bigpay',
  svg: bigpaySvg,
};
